import classNames from 'classnames';
import {
  Modal,
  PartialWidthContainer,
  TitledBlock,
  VerifyPassword,
} from 'components';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useAuthState } from 'state';
import { EditProfileAccount, EditProfile, EditProfilePicture } from './bricks';
import { GoToItem, MenuItem, BooleanInput } from './components';
import externalLinks from './externalLinks';
import styles from './ProfileEditScreen.module.scss';

/**
 * ProfileEditScreen
 *
 * @return {JSX.Element}
 */
const ProfileEditScreen = ({ className }) => {
  const authState = useAuthState();

  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  // const [error, setError] = useState('');
  // const [isLoading, setIsLoading] = useState(false);

  const handleLogout = () => authState.logout();
  const handleDeleteAccount = () => setIsDeletingAccount(true);
  const handleCancelDelete = () => setIsDeletingAccount(false);
  const proceedDeleteAccount = () => authState.deleteProfile();

  return (
    <PartialWidthContainer
      className={classNames(
        styles.ProfileEditScreen,
        className,
        `${ProfileEditScreen.displayName}`
      )}
      small
    >
      <Helmet title="Profile" />
      <EditProfilePicture />
      <TitledBlock title="App">
        <MenuItem>
          <BooleanInput
            title="Large property size"
            description="Makes viewing many properties easier."
          />
        </MenuItem>
      </TitledBlock>
      <EditProfile />
      <EditProfileAccount />
      <TitledBlock title="Legal">
        {externalLinks.map((block) => (
          <TitledBlock title={block.title} key={block.title}>
            {block.links.map((link) => (
              <MenuItem key={link.href}>
                <GoToItem
                  to={link.href}
                  external
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.title}
                </GoToItem>
              </MenuItem>
            ))}
          </TitledBlock>
        ))}
      </TitledBlock>
      <TitledBlock title="Account">
        <MenuItem>
          <GoToItem onClick={handleLogout}>Logout</GoToItem>
        </MenuItem>
        <MenuItem>
          <GoToItem onClick={handleDeleteAccount}>Delete account</GoToItem>
        </MenuItem>
      </TitledBlock>
      {isDeletingAccount ? (
        <Modal
          title="Delete Account"
          onClose={handleCancelDelete}
          showCloseButton
        >
          <VerifyPassword
            className={styles.VerifyModal}
            onSuccess={proceedDeleteAccount}
            // isLoading={isLoading}
          />
        </Modal>
      ) : null}
    </PartialWidthContainer>
  );
};

ProfileEditScreen.displayName = 'ProfileEditScreen';

export default ProfileEditScreen;
